import Http from "@/api/http.js"

export default {
  index(params = {}) {
    return Http.get("/financial_consolidated_reports", { params })
  },

  exportPdf(params = {}) {
    return Http.get("/financial_consolidated_reports/export", {
      params: { ...params, format: "pdf" },
      responseType: "blob",
    })
  },
}
